import { CurrencyPipe, DatePipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'
import { ChargeGrouping } from '@mmx/shared'
import { TranslateModule } from '@ngx-translate/core'

import { MultiVisitReviewRow } from '../../../services/estimate-balance-presenter.service'
import { type BalanceChargeBreakdownDialogData } from '../balance-charge-breakdown-dialog/balance-charge-breakdown-dialog.component'

@Component({
  selector: 'mmx-balance-visit-row',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CurrencyPipe, DatePipe, TranslateModule, MatButtonModule, MatIconModule, MatTooltipModule],
  templateUrl: './balance-visit-row.component.html',
  styleUrls: ['./balance-visit-row.component.scss'],
})
export class BalanceVisitRowComponent {
  readonly row = input.required<MultiVisitReviewRow>()
  readonly diff = input<'new' | 'renumbered' | null>(null)
  readonly renumberedFrom = input<number | null>(null)

  /** Emits the visit grouping when the PB pricer-trace button is clicked. */
  readonly pbTrace = output<ChargeGrouping>()
  /** Emits the visit grouping when the HB pricer-trace button is clicked. */
  readonly hbTrace = output<ChargeGrouping>()
  readonly chargeBreakdown = output<BalanceChargeBreakdownDialogData>()

  readonly dateFormat = 'MMM d, y, h:mm a'
  readonly useScheduledLabel = computed(() =>
    this.row().modeKey === 'scheduled' && this.row().appointmentStartAt != null,
  )
  readonly labelKey = computed(() =>
    this.useScheduledLabel()
      ? 'balance.review.row-label-scheduled'
      : 'balance.review.row-label-unscheduled',
  )
  readonly chargeCount = computed(() => this.row().charges.length)

  onPbTrace(): void {
    this.pbTrace.emit(this.toGrouping())
  }

  onHbTrace(): void {
    this.hbTrace.emit(this.toGrouping())
  }

  openChargeBreakdown(): void {
    const row = this.row()
    this.chargeBreakdown.emit({
      charges: row.charges,
      total: row.total,
    })
  }

  private toGrouping(): ChargeGrouping {
    return { visitNumber: this.row().visitNumber, appointmentId: this.row().appointmentId ?? undefined }
  }
}
